import { useStore } from '@/pages/aigc/hooks/useContext';
import { useLocation } from 'umi';
import { useAgentStoreContext } from './useLocalState';

// agent模块全局共享状态，使用到的地方，调用方法名即可
export const useAgentModalSata = () => {
  const [agentCfg, setAgentCfg] = useStore<{
    [key in string]: unknown;
  }>('agentSetting', {
    // 路径标识
    formKey: 'chat',
  });

  const handleOnClickSelfFormKey = (formKey: string) => {
    setAgentCfg({
      formKey,
    });
  };
  return {
    agentCfg,
    handleOnClickSelfFormKey,
  };
};

// 单独读取sessionId ,优先读取全局id，在读取url中的id
// 目前链路如下
// 1、落地页id一定是稳定的，只需关注url上面的id
// 2、copilot的id在离开、跳转等，会自动清空全局id，通过跳转url到达落地页，会携带当前的全局id，替换成落地页urlId，以此保证在Copilot关注全局id即可
// 3、在各个子系统跳转会发生一些不可预测的行为，如清空url对应的key，或者清空k对应v，等等，极其不可控，这里已经改造使用全局id，来保证稳定性
export const useSessionId = () => {
  const location: any = useLocation();
  const {
    query: { sessionId, snapshotId: snapshotId },
  } = location || {};
  const { getItem: agentSetItem } = useAgentStoreContext();
  // 监听这个状态
  const sessionCopilotId = agentSetItem('__dba_chat_copilot__');
  const routeSessionId = sessionId || sessionCopilotId;
  
  return {
    sessionId: routeSessionId,
    sessionCopilotId,
    originalSessionId: sessionId,
    snapshotId
  };
};